// extracted by mini-css-extract-plugin
export var home = "Home-module--home--21RFe";
export var homePrimary = "Home-module--home--primary--fCJD1";